//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex';
import constants from '~/constants';

export default {
  name: 'Character',

  data() {
    return {
      CDN: process.env.CDN,
      constants,
      activeCharacter: null,
      characterOrder: [5, 7, 6, 1, 4, 2, 3],
      characterList: [
        [
          {
            id: 5,
            name: 'Shen Gu Hong',
          },
          {
            id: 6,
            name: 'Tang Ching Tuan',
          },
          {
            id: 7,
            name: 'Tang Ching Fong',
          },
        ],
        [
          {
            id: 1,
            name: 'Hu Siao Bao',
          },
          {
            id: 2,
            name: 'A Nuan',
          },
          {
            id: 3,
            name: 'Jhao Wan Er',
          },
          {
            id: 4,
            name: 'Liou Fu Fong',
          },
        ],
      ],
    };
  },

  methods: {
    ...mapActions(['setCurrentModal']),
  },
};
